module.exports = __webpack_public_path__ + "img/nave-thumb.7064fd88.jpg";